module.exports = __webpack_public_path__ + "606521e3eaa66f31d6fb7bb6cc2eb0b8.svg";